import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-mdiicon',
	templateUrl:'./MDIIconPluginCompPage.html',
	styles: [],
	styleUrls:['./MDIIconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MDIIconPluginCompPage
{
	mdContent_1057 = `\`\`\`java
import com.jwebmp.plugins.materialicons.MDIIcon;
\`\`\``;
	mdContent_1058 = `\`\`\`java
MDIIcons icon
\`\`\``;
	mdContent_1059 = `\`\`\`java

\`\`\``;
	mdContent_1060 = `\`\`\`java
var icon = new MDIIcon&lt;&gt;(MDIIcons.account);
\`\`\``;
}
